// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.2_@swc+helpers@0.5.23__webpack@5.110.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.2_@swc+helpers@0.5.23__webpack@5.110.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-description-width {
  width: 200px;
}

.popover-width {
  width: 214px;
}
`, "",{"version":3,"sources":["webpack://./app/components/Transactions/TransactionsTable/styles.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".text-description-width {\n  width: 200px;\n}\n\n.popover-width {\n  width: 214px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
